import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { useSEO } from "@/components/Seo";

const inputCls =
  "w-full border border-white/15 bg-transparent px-4 py-3 text-sm text-white placeholder-white/30 outline-none transition-colors duration-300 focus:border-[#D4AF37]";

export default function AdminLogin() {
  useSEO("Studio Login | Threads Unbound™", "Threads Unbound studio admin.");
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (user) navigate("/admin");
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="flex min-h-screen items-center justify-center bg-[#0A0A0B] px-6" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-sm border border-white/10 p-10">
        <p className="text-[10px] uppercase tracking-[0.35em] text-[#D4AF37]">Studio access</p>
        <h1 className="mt-3 font-serif text-3xl font-light">
          Threads <span className="italic text-[#D4AF37]">Unbound</span>
        </h1>
        <div className="mt-8 space-y-5">
          <input
            type="email"
            required
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className={inputCls}
            data-testid="admin-login-email"
          />
          <input
            type="password"
            required
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className={inputCls}
            data-testid="admin-login-password"
          />
        </div>
        {error && (
          <p className="mt-4 text-sm text-red-400" data-testid="admin-login-error">
            {error}
          </p>
        )}
        <button
          type="submit"
          disabled={busy}
          data-testid="admin-login-submit"
          className="mt-8 w-full border border-[#D4AF37]/70 py-3 text-xs uppercase tracking-[0.25em] text-[#D4AF37] transition-colors duration-300 hover:bg-[#D4AF37] hover:text-black disabled:opacity-40"
        >
          {busy ? "Entering…" : "Enter the studio"}
        </button>
      </form>
    </main>
  );
}
